export default {
	"Lanuage":"언어",
	"Setting":"설정",
	"English":"영어",
	"Japanese":"일본어",
	"Korean":"한국어",
}
